<script setup lang="ts">
/**
 * No rail, no header, no session menu.
 *
 * For the screens a visitor from outside the organization is meant to reach — today just
 * certificate verification. Showing them navigation they cannot use would only lead to a
 * login form they have no account for.
 */
</script>

<template>
  <slot />
</template>
